import { Injectable } from '@angular/core';

import { EMPTY, Observable, of } from 'rxjs';

export interface TranslateOptions {
  /** If errors should be triggered for keys that miss translations. Default is true. */
  logErrors?: boolean;
}

export interface DdsLocaleValue {
  countrySite: string;
  language: string;
}

export abstract class LanguageService {
  static TTL: number = 7 * 24 * 60 * 60 * 1000;
  static FALLBACK_LANGUAGE = 'en';
  allowableLangs: string[] = [];

  abstract verifyLangAllowed(lang: string): void;
  abstract setLang(lang: string): void;
  abstract get countryCode(): Observable<string>;
  abstract get cookieValue(): string;
  abstract get lang(): Observable<string>;
  abstract get langKey(): Observable<string>;
  abstract get locale(): Observable<string>;
  abstract get localeValue(): string; // ex. 'en_HK' for hk-en
  abstract get langValue(): string; // ex. 'hk-en' for hk-en
  abstract get langKeyValue(): string; // ex. 'EN' for hk-en
  abstract get ddsLocaleValue(): DdsLocaleValue; // ex. { countrySite: 'HK', language: 'GB' } for hk-en
  abstract get localizations(): Observable<Record<string, unknown>>;
  abstract translate<T = string>(key: string | string[], args?: unknown, options?: TranslateOptions): Observable<T>;
  abstract translateMultiple<T = string[]>(keys: string[], args?: unknown, options?: TranslateOptions): Observable<T>;
}

@Injectable()
export class MockLanguageService extends LanguageService {
  constructor() {
    super();
  }

  get countryCode(): Observable<string> {
    return of('');
  }
  readonly cookieValue = '';
  get lang(): Observable<string> {
    return of('');
  }
  get langKey(): Observable<string> {
    return of('');
  }
  get locale(): Observable<string> {
    return of('');
  }
  readonly localeValue = '';
  readonly langValue = '';
  readonly langKeyValue = '';
  get ddsLocaleValue(): DdsLocaleValue {
    return undefined;
  }
  get localizations(): Observable<Record<string, unknown>> {
    return EMPTY;
  }

  /* istanbul ignore next */
  verifyLangAllowed(_lang: string): void {
    return;
  }

  /* istanbul ignore next */
  setLang(_lang: string): void {
    return;
  }

  translate<T = string>(key: string | string[], _args?: unknown, _options?: TranslateOptions): Observable<T> {
    if (Array.isArray(key)) {
      return of(key[key.length - 1] as T);
    }
    return of(key as T);
  }

  translateMultiple<T = string[]>(keys: string[], _args?: unknown, _options?: TranslateOptions): Observable<T> {
    return of(keys as T);
  }
}
